// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__erdV5","slider":"Carousel_slider__Cx7G3","slick-prev":"Carousel_slick-prev__qpTes","slick-next":"Carousel_slick-next__4z3TS"};